import React from 'react';
import PropTypes from 'prop-types';
import Hotspot from './Hotspot';


class HotspotHorse extends Hotspot {
    constructor(props) {
        super(props);
    }

    getPlainSVG(color) {
        return (
            <svg width="512px" height="512px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Group 4</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Group-4" transform="translate(0.000000, 1.000000)">
                    <ellipse id="Oval" stroke="#FFFCFC" fill={color} cx="19.5" cy="19" rx="19" ry="18.5"></ellipse>
                    <g id="Exploree-2" transform="translate(1.000000, 0.000000)">
                        <circle id="Oval" stroke="#FFFFFF" stroke-width="1.5" cx="18.75" cy="18.75" r="18.75"></circle>
                        <path d="M12.25,13.7456 L13.4592,13.7456 C13.6196,13.7456 13.7668,13.8346 13.8413,13.9766 C13.9158,14.1187 13.9053,14.2904 13.8141,14.4223 C12.9978,15.603 12.5664,17.0099 12.5664,18.4912 C12.5664,22.218 15.3403,25.25 18.75,25.25 C22.1597,25.25 24.9336,22.218 24.9336,18.4912 C24.9336,17.0101 24.5021,15.6031 23.6857,14.4223 C23.5945,14.2904 23.584,14.1187 23.6585,13.9766 C23.733,13.8346 23.8802,13.7456 24.0406,13.7456 L25.25,13.7456 L25.25,12.25 L21.7699,12.25 L21.7699,13.5377 C22.6857,14.6252 23.208,16.1577 23.208,17.7721 C23.208,19.2867 22.7581,20.7154 21.9412,21.7948 C21.0972,22.9101 19.9639,23.5243 18.75,23.5243 C17.5361,23.5243 16.4028,22.9101 15.5588,21.7948 C14.7419,20.7154 14.292,19.2867 14.292,17.7721 C14.292,16.1577 14.8143,14.6253 15.7301,13.5377 L15.7301,12.25 L12.25,12.25 L12.25,13.7456 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero"></path>
                        <rect id="Rectangle" fill={color} fill-rule="nonzero" x="17.25" y="12.25" width="3" height="1.33333"></rect>
                    </g>
                </g>
            </g>
        </svg>);
    }


}

HotspotHorse.propTypes = { primaryColor: PropTypes.string.isRequired, };
export default HotspotHorse;

